import styles from "./EllipsisLoader.module.css";

export default function EllipsisLoader() {
  return (
    <div className={styles.ldsEllipsis}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
